import React from 'react';
import { HelpCenterAttachmentsItem } from './HelpCenterAttachmentsItem';

import { AttachmentsContainer, AttachmentsTitle } from './styles';
import {
  AttachmentsHelpCenterType,
  HelpCenterTopic
} from '../../../store/ducks/help-center/types';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';

interface Props {
  categories?: string[];
  manuals?: HelpCenterTopic[];
}

type AttachmentLink = {
  title: string;
  href: string;
};

export const HelpCenterAttachments = ({ categories, manuals }: Props) => {
  if (!manuals && !categories) {
    return null;
  }

  const FAQ = useSelector((state: ApplicationState) => state.helpCenter.faq);

  const getFaqAttachments = (categoryIds: string[]): AttachmentLink[] => {
    // Questions Attachments
    const questionsAttachments = FAQ.question
      .filter((item) =>
        item.categories.some((itm) => categoryIds.includes(itm))
      )
      .reduce<AttachmentsHelpCenterType[]>(
        (acc, item) => [...acc, ...item.attachments],
        []
      );

    // Categories Attachments
    const categoriesAttachments = FAQ.categories
      .filter((item) => categoryIds.includes(item.id))
      .reduce<AttachmentsHelpCenterType[]>(
        (acc, item) => [...acc, ...item.attachments],
        []
      );

    // Unique Attachments
    return Array.from(
      new Map(
        [...categoriesAttachments, ...questionsAttachments].map((item) => [
          item.name,
          item
        ])
      ).values()
    ).map((item) => ({ title: item.name, href: `/faq/${item.file}` }));
  };

  const getManualsAttachments = (
    manualTopics: HelpCenterTopic[]
  ): AttachmentLink[] =>
    manualTopics.map((item) => ({
      title: item.title,
      href: `${
        process.env.REACT_APP_CUSTOMER_AUTHORIZATION
      }/commerce-media?file=${encodeURIComponent(
        item?.extension_attributes?.file_url ?? ''
      )}`
    }));

  const attachments = manuals
    ? getManualsAttachments(manuals)
    : getFaqAttachments(categories ?? []);

  if (attachments.length === 0) {
    return null;
  }

  return (
    <AttachmentsContainer>
      <AttachmentsTitle>Manuais</AttachmentsTitle>

      {attachments.map((item) => (
        <HelpCenterAttachmentsItem
          key={item.href}
          title={item.title}
          href={item.href}
        />
      ))}
    </AttachmentsContainer>
  );
};
